import React, { useEffect, useReducer, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfoIcon from '@mui/icons-material/Info';
import { FormControlLabel, Radio, RadioGroup, Button, IconButton } from '@material-ui/core';
import Tooltip from '@mui/material/Tooltip';
import {
  IN_ROOM_DINING_COMBO_ADDONS_GROUPED,
  IN_ROOM_DINING_COMBO_ADDONS_INACTIVE,
  IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED,
  IN_ROOM_DINING_COMBO_TAB,
  IN_ROOM_DINING_COMBO_TYPE,
} from '../../../../../constants/InRoomDiningConst';
import CustomFormView from '../../../../../shared/custom-form-view/Custom-Form-View';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { VALID_INTEGER, formDataValidate } from '../../../../../utils/formUtils';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import CustomMultiSelect from '../../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import {
  fetchAllInRoomDining,
  fetchAllInRoomDiningMenu,
  inRoomDiningAddOnSelector,
  inRoomDiningItemsSelector,
} from '../../../servicesSlice';
import CustomChipInput from '../../../../../shared/form-controls/custom-chip-input/Custom-Chip-Input';
import AddNewPopUPModel from '../../../../../shared/add-new-popup/Add-New-Popup-Model';
import {
  addInRoomDiningAddOn,
  createInRoomDiningCombo,
  updateInRoomDiningCombo,
} from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import { allHotelsSelector } from '../../../../property/propertySlice';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import EditIcon from '@mui/icons-material/Edit';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const InRoomDiningComboCreate = (props) => {
  const { toggleDrawer, combo, hotelId, restaurantId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const originalHotels = useSelector(allHotelsSelector);
  const itemsListData = useSelector(inRoomDiningItemsSelector);
  const originalAddons = useSelector(inRoomDiningAddOnSelector);
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [addNewValues, setAddNewValues] = useState({
    title: '',
    status: false,
  });
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [addOnError, setAddOnError] = useState(false);
  const [groupAddon, setGroupAddon] = useState([]);
  const [isEditGroupedAddon, setIsEditGroupedAddon] = useState({
    isEdit: false,
    customIndex: -1,
  });
  const [validLimit, setValidLimit] = useState(false);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Combo Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Combo Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    status: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    price: {
      value: '',
      fieldName: 'Combo Price',
      errors: {},
      validations: ['required', 'positiveOnly', VALID_INTEGER],
      tab: 0,
    },
    items: {
      value: [],
      fieldName: 'Items',
      errors: {},
      validations: [],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    addonsStatus: {
      value: 'active',
      fieldName: '',
      errors: {},
      validations: [],
      tab: 1,
    },
    limit: {
      value: 'active',
      fieldName: '',
      errors: {},
      validations: [],
      tab: 1,
    },
    value: {
      value: '',
      fieldName: 'Maximum selection limit',
      errors: {},
      validations: ['required', 'positiveOnly'],
      tab: 1,
    },
    addons: {
      value: [],
      fieldName: 'Add-on Name',
      errors: {},
      validations: ['required'],
      tab: 1,
    },
    groupedAddon: {
      value: [],
      fieldName: 'Grouped Add-on',
      errors: {},
      validations: [],
      tab: 1,
    },
    groupTitle: {
      value: '',
      fieldName: 'Group Title',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    groupAddonsMaxLimit: {
      value: '',
      fieldName: 'Maximum selection Limit',
      errors: {},
      validations: ['required', 'positiveOnly'],
      tab: -1,
    },
    groupAddonsId: {
      value: [],
      fieldName: 'Add-on',
      errors: {},
      validations: ['required'],
      tab: -1,
    },
    upsellStatus: {
      value: 'active',
      fieldName: '',
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    upsellItems: {
      value: [],
      fieldName: `Upsell items`,
      errors: {},
      validations: ['required'],
      tab: 2,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 3,
    },
  });
  const [addonsFormData, setAddonsFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      name: {
        value: '',
        fieldName: 'Add-on Name',
        errors: {},
        validations: ['required'],
        tab: 0,
      },
      code: {
        value: '',
        fieldName: 'Addon Code',
        errors: {},
        validations: ['required', 'validAlphaNumeric'],
        tab: 0,
      },
      price: {
        value: '',
        fieldName: 'Price',
        errors: {},
        validations: ['required'],
        tab: 0,
      },
      status: {
        value: true,
        fieldName: 'Active',
        errors: {},
        validations: [],
        tab: 0,
      },
    },
  );

  useEffect(() => {
    if (itemsListData) setItemList(itemsListData);
  }, [setItemList, itemsListData]);
  const activeAddons = originalAddons?.filter((item) => item?.status === true);
  const activeAddonIds = useMemo(() => new Set(activeAddons?.map((a) => a.id)), [activeAddons]);

  useEffect(() => {
    const filteredGroupedAddons = formData.groupedAddon.value.filter((group) =>
      group.addons.every((addon) => activeAddonIds.has(addon)),
    );
    setGroupAddon(filteredGroupedAddons);
  }, [formData.groupedAddon.value]);

  useEffect(() => {
    if (combo) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = combo[field];
      }
      currFields.items.value = combo.items || [];
      currFields.addons.value = [];
      currFields.addons.validations = [];
      currFields.limit.value = 'inactive';
      currFields.value.validations = [];
      currFields.groupedAddon.value = [];
      currFields.groupedAddon.validations = [];
      currFields.groupTitle.value = '';
      currFields.groupAddonsMaxLimit.value = '';
      currFields.groupAddonsId.value = [];
      if (combo.addons.type === IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED) {
        currFields.addonsStatus.value = 'active';
        currFields.addons.value = combo.addons.addons;
        currFields.addons.validations = ['required'];
        if (combo.addons.limit === true) {
          currFields.limit.value = 'active';
          currFields.value.validations = ['required', 'positiveOnly'];
          currFields.value.value = combo.addons.value;
        }
      } else if (combo.addons.type === IN_ROOM_DINING_COMBO_ADDONS_GROUPED) {
        currFields.addonsStatus.value = 'grouped';
        currFields.groupedAddon.value = combo.addons.groupedAddon;
        currFields.groupedAddon.validations = ['required'];
      } else {
        currFields.addonsStatus.value = 'inactive';
      }
      currFields.upsellStatus.value = combo.upsell.status ? 'active' : 'inactive';
      currFields.upsellItems.value = combo.upsell.items || [];
      currFields.upsellItems.validations = combo.upsell.status ? ['required'] : [];
      currFields.images.value = combo.images || [];
      currFields.customAttributes.value = combo.customAttributes || [];
      setGroupAddon(currFields.groupedAddon.value);
      setFormData(currFields);
    }
  }, [combo]);

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const validate = (tabValue, formObject, formType) => {
    const updatedFields = {};
    // If tabValue is given, filter out the form fields in current tab
    const currTabFromData = Object.fromEntries(
      Object.entries(formObject).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    if (formType === 'formData') setFormData(updatedFields);
    else setAddonsFormData(updatedFields);
    if (tabValue === 1 && groupAddon.length > 0) {
      return true;
    }
    return isValid;
  };

  const onClickNext = () => {
    if (validate(tabValue, formData, 'formData')) {
      setTabValue(tabValue + 1);
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else if (validate(tabValue, formData, 'formData')) {
      if (tabValue == 1 && validLimit) {
        return;
      }
      setTabValue(newValue);
    }
  };

  const handleSubmit = async (e) => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    try {
      dispatch(stepUpLoaderCount());
      e.preventDefault();
      if (
        !validate(0, formData, 'formData') ||
        !validate(1, formData, 'formData') ||
        !validate(2, formData, 'formData')
      ) {
        if (!validate(0, formData, 'formData')) setTabValue(0);
        else if (!validate(1, formData, 'formData')) setTabValue(1);
        else if (!validate(2, formData, 'formData')) setTabValue(2);
        notificationManager('danger', 'Enter all required fields');
        return false;
      }
      toggleDrawer('', false, '');
      setLoading(true);
      const images = await getProcessedImages(
        rawImages,
        originalHotels.find((hotel) => hotel.id === hotelId).groupId,
        IN_ROOM_DINING_COMBO_TYPE,
        hotelId,
      );
      let payload = {
        hotelId,
        code: formData.code.value,
        name: formData.name.value,
        status: formData.status.value,
        price: Number(formData.price.value),
        description: formData.description.value,
        items: formData.items.value,
        restaurantId,
        addonsStatus: formData.addonsStatus.value === 'active' ? true : false,
        limit: formData.limit.value === 'active' ? true : false,
        value: formData.value.value ? Number(formData.value.value) : 0,
        addons: {},
        upsellStatus: formData.upsellStatus.value === 'active' ? true : false,
        upsellItems: formData.upsellItems.value,
        customAttributes: formData.customAttributes.value,
        images,
      };
      if (formData.addonsStatus.value === 'active') {
        payload.addons.type = IN_ROOM_DINING_COMBO_ADDONS_UNGROUPED;
        payload.addons.addons = formData.addons.value;
        if (formData.limit.value === 'active') {
          payload.addons.limit = true;
          payload.addons.value = formData.value.value;
        } else {
          payload.addons.limit = false;
        }
      } else if (formData.addonsStatus.value === 'grouped') {
        payload.addons.type = IN_ROOM_DINING_COMBO_ADDONS_GROUPED;
        payload.addons.groupedAddon = formData.groupedAddon.value;
      } else {
        payload.addons.type = IN_ROOM_DINING_COMBO_ADDONS_INACTIVE;
        payload.addons.limit = false;
      }
      if (combo?.id) {
        payload.id = combo.id;
        await updateInRoomDiningCombo(payload, language);
        notificationManager('success', 'Combo updated successfully');
      } else {
        await createInRoomDiningCombo(payload, language);
        notificationManager('success', 'Combo created successfully');
      }
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      dispatch(fetchAllInRoomDiningMenu(hotelId, restaurantId));
      setLoading(false);
    } catch (error) {
      if (error.graphQLErrors) {
        if (error?.graphQLErrors?.[0]?.message === 'bundle name already exists')
          notificationManager('danger', 'Combo name already exists');
        else if (error?.graphQLErrors?.[0]?.message === 'bundle code already exists')
          notificationManager('danger', 'Combo code already exists');
      } else notificationManager('danger', 'Error occurred while creating the combo');
      setLoading(false);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onSearchItemList = async (searchItem) => {
    setSearchValue(searchItem);
    if (searchItem === '') return setItemList(itemsListData);
    const filterList = await itemsListData.filter((item) => {
      return item.name.toLowerCase().includes(searchItem.toLowerCase());
    });
    return setItemList(filterList);
  };

  const RenderCustomDisplay = (selectedValue) => {
    const displayName = selectedValue.map((itemData) => {
      const item = itemsListData.find((ild) => ild.id === itemData);
      return item?.name;
    });
    const formItem = { ...formData.items };
    formItem.fieldName = `${selectedValue.lenght} selected`;
    return <span>{displayName.join(', ')}</span>;
  };

  const onChangeItem = (e) => {
    const items = { ...e };
    e.fieldName = `${e.value.length} selected`;
    setFormData({ items });
  };

  const onChangeAddonStatus = (e, type) => {
    const addonsStatus = { ...formData.addonsStatus };
    const limit = { ...formData.limit };
    const value = { ...formData.value };
    const addons = { ...formData.addons };
    const groupedAddon = { ...formData.groupedAddon };
    const groupAddonsId = { ...formData.groupAddonsId };
    const groupTitle = { ...formData.groupTitle };
    const groupAddonsMaxLimit = { ...formData.groupAddonsMaxLimit };
    if (type === 'addonsStatus') {
      addonsStatus.value = e.target.value;
      limit.value = e.target.value;
      value.validations = limit.value === 'active' ? ['required', 'positiveOnly'] : [];
      value.value = '';
      addons.value = [];
      addons.validations = addonsStatus.value === 'inactive' ? [] : ['required'];
      groupedAddon.validations = addonsStatus.value === 'grouped' ? ['required'] : [];
      groupedAddon.value = [];
      groupAddonsId.value = [];
      groupTitle.value = '';
      groupAddonsMaxLimit.value = '';
    } else {
      limit.value = e.target.value;
      value.validations = limit.value === 'active' ? ['required', 'positiveOnly'] : [];
      value.value = '';
    }
    setFormData({
      addonsStatus,
      limit,
      value,
      addons,
      groupedAddon,
      groupAddonsId,
      groupTitle,
      groupAddonsMaxLimit,
    });
  };

  const openAddonsModal = (e) => {
    addonsFormData.name.value = e;
    setAddNewValues({
      title: 'Add-on',
      status: true,
    });
  };

  const handlePopupClose = () => {
    setAddNewValues({
      title: '',
      status: false,
    });
  };

  const onCLickAddAddons = async () => {
    if (hotelId && validate(0, addonsFormData, 'addonsFormData')) {
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      try {
        const payload = {
          name: addonsFormData.name.value,
          code: addonsFormData.code.value,
          price: addonsFormData.price.value,
          status: addonsFormData.status.value,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        const resp = await addInRoomDiningAddOn(payload, language);
        const addOnFormData = formData.addons;
        const updateAddOnId = [...addOnFormData.value, resp.data.createIRDAddon.id];
        addOnFormData.value = [...updateAddOnId];
        setFormData({ groupAddonsId: addOnFormData });
        notificationManager('success', 'Add-ons created successfully');
        addonsFormData.name.value = '';
        addonsFormData.code.value = '';
        addonsFormData.price.value = '';
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        formData.addons.errors = { required: null };
        if (formData.addonsStatus.value === 'grouped') {
          formData.addons.validations = ['required'];
        }
        handlePopupClose();
      } catch (e) {
        if (e.graphQLErrors) {
          notificationManager('danger', e.graphQLErrors[0].message);
        } else {
          notificationManager('danger', 'Add-ons creation failed');
        }
      }
      handlePopupClose();
    }
  };

  const handlePriceInput = (e, maxLength, field) => {
    if (e.value < 0) e.value = 0;
    if (e.value.length > maxLength) e.value = Math.floor(e.value / 10);
    const currValueField = { ...addonsFormData[field] };
    currValueField.value = e.value;
    setAddonsFormData({ [field]: currValueField });
  };

  const renderModelAddons = () => {
    return (
      <div>
        <div className='mx-4'>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={addonsFormData.name}
              handleInputChange={(e) => {
                setAddonsFormData({ name: e });
              }}
              maxLength={100}
              endAdornment={true}
              characterCount={true}
              multiline={true}
            />
          </div>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={addonsFormData.code}
              handleInputChange={(e) => {
                setAddonsFormData({ code: e });
              }}
              maxLength={8}
            />
          </div>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={addonsFormData.price}
              handleInputChange={(e) => {
                handlePriceInput(e, 8, 'price');
              }}
              type='number'
            />
          </div>
        </div>
      </div>
    );
  };
  const onChangeUpsellStatus = (e, type) => {
    const field = formData[type];
    field.value = e.target.value;
    const upsellItems = { ...formData.upsellItems };
    if (type === 'upsellStatus') {
      upsellItems.validations = e.target.value === 'active' ? ['required'] : [];
      upsellItems.value = [];
    }
    setFormData({ [type]: field, upsellItems });
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images];
    images.splice(index, 1);
    setFormData({ images });
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);

    if (tabValue === 1) {
      if (formData.addonsStatus.value === 'grouped') {
        const hasValidGroup =
          groupAddon.length > 0 &&
          groupAddon?.every(
            (group) =>
              group?.addons.length > 0 && group?.addons?.every((id) => activeAddonIds?.has(id)),
          );
        setIsTabInValid(!hasValidGroup);
      } else if (formData?.addonsStatus?.value === 'active') {
        const hasValidUngrouped =
          formData.addons.value.length > 0 &&
          formData?.addons?.value?.every((id) => activeAddonIds.has(id));
        setIsTabInValid(!(isValid && hasValidUngrouped));
      } else {
        setIsTabInValid(!isValid);
      }
    } else {
      setIsTabInValid(!isValid);
    }
  }, [formData, tabValue, groupAddon, activeAddonIds]);

  const onDeleteGroup = (e, index) => {
    e.preventDefault();
    const currField = { ...formData.groupedAddon };
    const cstm = [...currField.value];
    setGroupAddon(cstm);
    cstm.splice(index, 1);
    currField.value = cstm;
    setFormData({ groupedAddon: currField });
  };

  useEffect(() => {
    if (tabValue === 1) {
      if (
        formData.addonsStatus.value === 'active' &&
        formData.limit.value === 'active' &&
        formData.value.value
      ) {
        const activeSelectedAddons = formData.addons.value.filter((id) => activeAddonIds.has(id));
        const hasNoActiveAddons = activeSelectedAddons.length === 0;
        const limitExceedsActiveAddons = activeSelectedAddons.length < formData.value.value;
        setValidLimit(!hasNoActiveAddons && limitExceedsActiveAddons);
      } else {
        setValidLimit(false);
      }
    } else {
      setValidLimit(false);
    }
  }, [
    formData.addons.value,
    formData.limit.value,
    formData.value.value,
    formData.addonsStatus.value,
    activeAddonIds,
    tabValue,
  ]);

  const onAddGroupedAddons = () => {
    const title = formData.groupTitle.value;
    const limit = formData.groupAddonsMaxLimit.value;
    const addons = formData.groupAddonsId.value;
    if (title && limit && addons.length > 0) {
      setAddOnError(false);
      const currentInput = {
        title,
        limit,
        addons,
      };
      if (isEditGroupedAddon.isEdit) {
        const currField = { ...formData.groupedAddon };
        const addOnData = [...currField.value];
        addOnData[isEditGroupedAddon.customIndex] = currentInput;
        currField.value = addOnData;
        setGroupAddon(addOnData);
        setFormData({ groupedAddon: currField });
        setIsEditGroupedAddon({ isEdit: false, customIndex: -1 });
      } else {
        const currField = { ...formData.groupedAddon };
        const itemIndex = currField.value.findIndex(
          (groupedAddonItem) => groupedAddonItem.name === title,
        );
        if (itemIndex === -1) {
          const addOnData = [...currField.value, currentInput];
          setGroupAddon(addOnData);
          currField.value = addOnData;
          setFormData({ groupedAddon: currField });
        } else {
          const addOnData = [...currField.value];
          addOnData[itemIndex] = currentInput;
          setGroupAddon(addOnData);
          currField.value = addOnData;
          setFormData({ groupedAddon: currField });
        }
      }
      formData.groupTitle.value = '';
      formData.groupAddonsMaxLimit.value = '';
      formData.groupAddonsId.value = [];
      formData.addons.validations = [];
      if (formData.addonsStatus.value === 'grouped') {
        formData.addons.validations = ['required'];
      }
    }
  };

  const getAddonForGroup = (addonForGroup) => {
    const addonArray = originalAddons.filter((addon) => {
      return addonForGroup.includes(addon.id);
    });
    return (
      <div className='row d-inline-flex'>
        {addonArray
          .map((item) => {
            return item.name;
          })
          .join(', ')}
      </div>
    );
  };

  const onClickEditGroup = async (e, key, index) => {
    e.preventDefault();
    setIsEditGroupedAddon({ isEdit: true, customIndex: index });
    const currFields = { ...formData };
    currFields.groupTitle.value = key.title;
    currFields.groupAddonsMaxLimit.value = key.limit;
    currFields.groupAddonsId.value = key.addons;
    setFormData(currFields);
  };

  return (
    <CustomFormView
      handleSubmit={handleSubmit}
      tabTitle={IN_ROOM_DINING_COMBO_TAB}
      onCancel={onCancel}
      tabValue={tabValue}
      maxtab={3}
      isTabInValid={isTabInValid}
      isUpdate={combo ? true : false}
      loading={loading}
      handleTabChange={handleTabChange}
      title={`${combo ? 'Edit' : 'Add'} Combo`}
      onClickNext={onClickNext}
      titleClass='col-md-4'
      tabClass='col-md-6'
      cancelClass='col-md-2 '
      validLimit={validLimit}
    >
      {tabValue === 0 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
                maxLength={8}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.description}
                handleInputChange={(e) => {
                  setFormData({ description: e });
                }}
                multiline={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.price}
                type='number'
                min={0}
                max={99999999}
                handleInputChange={(e) => {
                  setFormData({ price: e });
                }}
              />
            </div>
          </div>
          <div className='row w-100 mt-2'>
            <div className='col-auto d-inline-flex align-items-center '>
              <CustomCheckbox
                item={formData.status}
                handleInputChange={(e) => setFormData({ status: e })}
                color='primary'
              />
              <Tooltip title='Deactivating this, hides it from Guest app' placement='right'>
                <InfoIcon fontSize='small' />
              </Tooltip>
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-md-6 mb-3'>
              <CustomMultiSelect
                item={formData.items}
                options={itemList}
                hideNullOption={true}
                valueField='id'
                labelField='name'
                handleInputChange={(e) => onChangeItem(e)}
                isSearchable={true}
                getSearchInput={onSearchItemList}
                searchValue={searchValue}
                searchPlaceholder='Search'
                isCustomDisplay={true}
                renderCustomDisplay={RenderCustomDisplay}
              />
            </div>
          </div>
          <KeyValuePairList
            item={formData.customAttributes}
            onListChange={(e) => {
              setFormData({ customAttributes: e });
            }}
          />
        </div>
      )}
      {tabValue === 1 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Add-ons</h4>
          <div className='row'>
            <div className='col-md-12'>
              <RadioGroup
                row
                value={formData.addonsStatus.value}
                name='radio-buttons-group'
                onChange={(e) => onChangeAddonStatus(e, 'addonsStatus')}
              >
                <FormControlLabel
                  value='grouped'
                  control={<Radio color='primary' />}
                  label='Grouped'
                  className='col-md-3'
                />
                <FormControlLabel
                  value='active'
                  control={<Radio />}
                  label='Ungrouped'
                  className='col-md-4'
                />
                <FormControlLabel
                  value='inactive'
                  control={<Radio />}
                  label='Inactive'
                  className='col-md-4'
                />
              </RadioGroup>
            </div>
            {formData.addonsStatus.value === 'grouped' && (
              <div>
                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={formData.groupTitle}
                      handleInputChange={(e) => {
                        setFormData({ groupTitle: e });
                      }}
                    />
                  </div>
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={formData.groupAddonsMaxLimit}
                      handleInputChange={(e) => {
                        setFormData({ groupAddonsMaxLimit: e });
                      }}
                      type='number'
                      min={0}
                      max={100}
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <CustomChipInput
                    options={activeAddons}
                    labelField='name'
                    textFieldLabel='Add-ons'
                    textFieldPlaceholder='Select Add-ons'
                    isAddNewEnabled={true}
                    onClickAddNew={openAddonsModal}
                    formData={formData}
                    setFormData={setFormData}
                    formField='groupAddonsId'
                  />
                </div>
                <div className='me-3 col-md-4 row mt-2 mb-2'>
                  <Button
                    variant='outlined'
                    color='primary'
                    disabled={
                      !formData.groupTitle.value ||
                      !formData.groupAddonsMaxLimit.value ||
                      !formData.groupAddonsId.value ||
                      formData.groupAddonsId.value.length < formData.groupAddonsMaxLimit.value
                    }
                    onClick={onAddGroupedAddons}
                    size='large'
                    className='me-3 col-md-4'
                  >
                    Add
                  </Button>
                </div>
                {addOnError && formData.groupedAddon.value.length === 0 && (
                  <p style={{ color: 'red' }}>Grouped Addon is required</p>
                )}
                {groupAddon && groupAddon.length > 0 && (
                  <div className='col-md-12 mt-3'>
                    {groupAddon.map((groupKey, groupIndex) => (
                      <div
                        className='row details-value d-flex mt-2 mb-2 customDisplay p-1'
                        key={groupIndex}
                      >
                        <div className='col-md-10 ml-2'>
                          <span className='ingredientName'>
                            {groupKey.title} ({groupKey.limit}):{' '}
                          </span>
                          <span> {getAddonForGroup(groupKey.addons)}</span>
                        </div>
                        <div className='col-md-1'>
                          <IconButton
                            aria-label='edit'
                            onClick={(e) => onClickEditGroup(e, groupKey, groupIndex)}
                          >
                            <EditIcon fontSize='12' className='icon' />
                          </IconButton>
                        </div>
                        <div className='col-md-1'>
                          <IconButton
                            aria-label='delete'
                            onClick={(e) => onDeleteGroup(e, groupIndex)}
                          >
                            <RemoveCircleIcon fontSize='12' className='icon' />
                          </IconButton>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {formData.addonsStatus.value === 'active' && (
              <>
                <div className='px-3 w-100 d-flex mb-3 mt-4'>
                  <div className='col-md-1'>
                    <h4 className='tab-title'>Limit</h4>
                  </div>
                  <div className='col-md-3'>
                    <Tooltip
                      title='Limit is the maximum add-on options that the user can select form an item'
                      placement='right-end'
                    >
                      <InfoIcon />
                    </Tooltip>
                  </div>
                </div>
                <RadioGroup
                  row
                  value={formData.limit.value}
                  name='radio-buttons-group'
                  onChange={(e) => onChangeAddonStatus(e, 'limit')}
                >
                  <FormControlLabel
                    value='active'
                    control={<Radio />}
                    label='Active'
                    className='col-md-4'
                  />
                  <FormControlLabel
                    value='inactive'
                    control={<Radio />}
                    label='Inactive'
                    className='col-md-4'
                  />
                </RadioGroup>
                {formData.limit.value === 'active' && (
                  <div className='col-md-6 mb-3'>
                    <CustomTextField
                      item={formData.value}
                      type='number'
                      min={0}
                      max={99999999}
                      handleInputChange={(e) => {
                        setFormData({ value: e });
                      }}
                    />
                  </div>
                )}
                <div className='col-md-12 mb-3'>
                  <CustomChipInput
                    options={activeAddons}
                    labelField='name'
                    textFieldLabel='Add-ons'
                    textFieldPlaceholder='Select Add-ons'
                    isAddNewEnabled={true}
                    onClickAddNew={openAddonsModal}
                    formData={formData}
                    setFormData={setFormData}
                    formField='addons'
                  />
                </div>
                {validLimit && (
                  <p className='field-error mt-2'>
                    Add-Ons should be more than or equal to the maximum selection limit
                  </p>
                )}
              </>
            )}
          </div>
          {addNewValues && addNewValues.status === true && (
            <AddNewPopUPModel
              addNewPopUp={addNewValues}
              onClickAdd={onCLickAddAddons}
              onClickCancel={handlePopupClose}
              renderModel={renderModelAddons}
              formData={addonsFormData}
            />
          )}
        </div>
      )}
      {tabValue === 2 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Upsell Items</h4>
          <div className='row'>
            <div className='col-md-12'>
              <RadioGroup
                row
                value={formData.upsellStatus.value}
                name='radio-buttons-group'
                onChange={(e) => onChangeUpsellStatus(e, 'upsellStatus')}
              >
                <FormControlLabel
                  value='active'
                  control={<Radio />}
                  label='Active'
                  className='col-md-4'
                />
                <FormControlLabel
                  value='inactive'
                  control={<Radio />}
                  label='Inactive'
                  className='col-md-4'
                />
              </RadioGroup>
            </div>
            {formData.upsellStatus.value === 'active' && (
              <div className='row'>
                <div className='col-md-6'>
                  <CustomMultiSelect
                    item={formData.upsellItems}
                    options={itemList}
                    hideNullOption={true}
                    valueField='id'
                    labelField='name'
                    handleInputChange={(e) => setFormData({ upsellItems: e })}
                    isSearchable={true}
                    getSearchInput={onSearchItemList}
                    searchValue={searchValue}
                    searchPlaceholder='Search'
                    isCustomDisplay={true}
                    renderCustomDisplay={RenderCustomDisplay}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {tabValue === 3 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <ImageUpload
            uploadedImages={formData.images.value}
            imgList={rawImages}
            onImageListUpdated={onImageListUpdated}
            onUploadedImageRemoval={onUploadedImageRemoval}
            onImagesLoading={(status) => {
              setLoading(status);
            }}
            enabledMediaTabs={['image']}
          />
        </div>
      )}
    </CustomFormView>
  );
};

export default InRoomDiningComboCreate;
